import type React from 'react';

import { CtaSection } from './components/CtaSection';
import { CuratedTopicsSection } from './components/CuratedTopicsSection';
import { FilterableTopics } from './components/FilterableTopics';

export const PageBody: React.FC = () => {
	return (
		<>
			<FilterableTopics />
			<CuratedTopicsSection />
			<CtaSection />
		</>
	);
};
